import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DestroyNotifierDirective } from '@shared/directives/destroy-notifier.directive';
import { ModalDirective } from '@shared/directives/modal.directive';

@Component({
  standalone: false,
  selector: 'hm-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  hostDirectives: [DestroyNotifierDirective],
})
export class ModalComponent extends ModalDirective implements OnInit {
  private readonly destroyNotifier = inject(DestroyNotifierDirective);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.destroyNotifier.sink = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.close();
      });
  }
}
